<template lang="pug">
.card-coupons-container(
  v-if="info.type",
  :class="[ \
    'type-' + info.type, \
    'status-' + info.status, \
     info.corner ? 'with-corner' : '', \
     info.disabled ? 'disabled' : '', \
  ]",
  @click="click"
)
  .corner.flex-mid(v-if="info.corner")
    span {{ info.corner }}
  .left-container
    .left.column(v-if="info.type !== CARD_COUPON_TYPE.FREE_COUPON")
      .price(:class="['length-' + info.currentPriceV2[0].value.length]")
        span.current {{ info.currentPriceV2[0].value }}
        span.unit {{ info.currentPriceV2[0].unit }}
    .mid.column
      .title {{ info.title||'' }}
      .assets(v-if="info.assets") {{ info.assets }}
      .words(v-if="info.marketingWords&&info.marketingWords.length>0")
        span.word-item(v-for="word in info.marketingWords.slice(0, 2)") {{word.wordsValue}}
      template(
        v-if="[CARD_COUPON_TYPE.FREE_COUPON, CARD_COUPON_TYPE.TIME_COUPON].indexOf(info.type) + 1"
      )
        .subtitle {{ info.subtitle }}
      template(v-else)
        .subtitle(v-if="info.type !== 3")
          span.origin-price(v-if="info.originPrice") {{ info.originPrice }}
          span.diff &nbsp;{{ info.diff }}
      .process(v-if="info.percentage && info.type === 3")
        .line
          .colored(:style="{ width: info.percentage + '%' }")
        .status 已抢{{ info.status === TIME_COUPON_STATUS.NONE ? '100' : info.percentage }}%
  .right.column
    .btn.flex-mid(@click="$emit('btn', info)") {{ btn }}
      .hint(v-if="showDouble")
        span 最高2倍
    .direct-use.flex-mid(v-if="showDouble", @click="$emit('use', info)")
      span 直接用
      .common-arrow-right
</template>

<script>
import { getFinalBuyPrice } from '../../card-for-app/utils';
import { MARKET_OFFER_TYPE } from '../../../const';
import { CARD_COUPON_TYPE, TIME_COUPON_STATUS } from '../consts';

export default {
  props: {
    info: {
      type: Object,
      // default: () => ({
      //   title: '单车骑行卡·30天不限次单车骑行卡·30天不限次',
      //   subtitle: '乘客确认到达可到账',
      //   originPrice: '20',
      //   diff: '平台补4.2元',
      //   type: CARD_COUPON_TYPE.TIME_COUPON,
      //   corner: '可膨胀',
      //   assets: '5元乘客券×4',
      //   percentage: '20',
      //   disabled: true,
      //   status: TIME_COUPON_STATUS.NONE,
      // }),
      default: null,
    },
  },
  data() {
    return {
      TIME_COUPON_STATUS,
      CARD_COUPON_TYPE,
      MARKET_OFFER_TYPE,
    };
  },
  computed: {
    showDouble() {
      return (
        (this.info.type === CARD_COUPON_TYPE.TIME_COUPON
          || this.info.type === CARD_COUPON_TYPE.FREE_COUPON)
        && this.info.status === TIME_COUPON_STATUS.DOUBLE
      );
    },
    buyPrice() {
      return getFinalBuyPrice(this.info);
    },
    btn() {
      if (this.info.type === CARD_COUPON_TYPE.TIME_COUPON) {
        if (this.info.status === TIME_COUPON_STATUS.NONE) {
          return this.info.btn || '已抢完';
        }
        if (this.info.status === TIME_COUPON_STATUS.USE) {
          return '去使用';
        }
        if (this.info.status === TIME_COUPON_STATUS.GRAB) {
          return '立即抢';
        }
        if (this.info.status === TIME_COUPON_STATUS.DOUBLE) {
          return '去膨胀';
        }
      }
      if (this.info.type === CARD_COUPON_TYPE.FREE_COUPON) {
        if (this.info.status === TIME_COUPON_STATUS.NONE) {
          return this.info.btn || '已抢完';
        }
        if (this.info.status === TIME_COUPON_STATUS.GET) {
          return '领取';
        }
        if (this.info.status === TIME_COUPON_STATUS.DOUBLE) {
          return '去膨胀';
        }
        if (this.info.status === TIME_COUPON_STATUS.USE) {
          return '去使用';
        }
      }
      return this.info.btn || '购买';
    },
  },
  methods: {
    click() {
      this.$emit('click', this.info);
    },
  },
};
</script>

<style lang="less" scoped>
.mixin-btn-border() {
  width: 0.68rem;
  height: 0.25rem;
  border-radius: 0.13rem;
  border: 1px solid #ff6011;
  color: #ff5526;
  background: inherit;
}

.card-coupons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  border-radius: 0.08rem;
  box-sizing: border-box;
  background-size: 100% 100%;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;

  &.with-corner {
    padding-bottom: 0.17rem;
  }

  .column {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .left {
    width: 0.8rem;
  }

  .words {
    display: flex;
    white-space: nowrap;
    margin-top: 0.02rem;
    margin-bottom: -0.08rem;
    max-width: 1.7rem;
    overflow: hidden;

    .word-item {
      display: inline-block;
      background: #ffe5c0;
      border-radius: 0.01rem;
      font-size: 0.11rem;
      color: #974800;
      padding: 1px 4px;

      &:not(:last-of-type) {
        margin-right: 0.08rem;
      }
    }
  }

  .mid {
    flex: 1;
    max-width: 1.65rem;
    align-items: flex-start;
    justify-content: flex-start;
    white-space: nowrap;
  }

  .right {
    padding-right: 0.1rem;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .btn {
    width: 0.6rem;
    height: 0.25rem;
    background: linear-gradient(90deg, #d7a76b 0%, #b2793d 100%);
    border-radius: 0.13rem;
    font-size: 0.12rem;
    font-weight: 500;
    color: #fff;
  }

  .title {
    font-size: 0.14rem;
    font-weight: 500;
    min-height: 0.14rem;
    line-height: 1;
    color: #242729;
    max-width: 1.65rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: keep-all;
    word-wrap: normal;
  }

  .price {
    white-space: nowrap;

    > .unit {
      font-size: 0.12rem;
      font-weight: 600;
      color: #845529;
      margin-left: 2px;
    }
  }

  .assets {
    font-size: 0.11rem;
    color: #5a6066;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 1.65rem;
    margin-top: 0.06rem;
    margin-bottom: -0.06rem;
  }

  .subtitle {
    display: flex;
    margin-top: 0.1rem;
    font-size: 0.12rem;
    color: #879099;
    max-width: 1.65rem;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: keep-all;
    word-wrap: normal;
  }

  .direct-use {
    display: flex;
    margin-top: 0.05rem;
    font-size: 0.12rem;
    font-weight: 600;
    color: #ff6940;

    .common-arrow-right {
      border-color: #ff6940;
      margin-left: -3px;
    }
  }

  .process {
    display: flex;
    align-items: center;
    margin-top: 0.05rem;

    .line {
      position: relative;
      width: 0.74rem;
      height: 0.05rem;
      border-radius: 0.025rem;
      background: #f6c9ac;
    }

    .colored {
      position: absolute;
      left: 0;
      top: 0;
      height: 0.05rem;
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
      border-radius: 0.025rem;
    }

    .status {
      margin-left: 0.05rem;
      font-size: 0.1rem;
      font-weight: 500;
      color: #ed7043;
    }
  }

  .origin-price {
    color: #b5876f;
    text-decoration: line-through;
  }

  .diff {
    color: #b67e42;
    font-weight: 600;
  }

  .current {
    font-size: 0.3rem;
    font-weight: bold;
    font-family: "DIN Alternate Bold", sans-serif;
    color: #ae5505;
    line-height: 1;
    letter-spacing: -1px;
    position: relative;
    top: 1px;
  }

  .corner {
    position: absolute;
    top: 0;
    left: 0;
    height: 0.15rem;
    background: #ec5e40;
    border-radius: 0.08rem 0 0.08rem 0;
    font-size: 10px;
    line-height: 1;
    padding: 0.01rem 0.06rem;
    color: rgba(255, 255, 255, 1);

    span {
      display: inline-block;
      transform: scale(1.1);
      transform-origin: center center;
    }
  }

  .left-container {
    display: flex;
    align-items: center;
    flex: 1;
    height: 100%;
  }

  &.type-2 {
    height: 0.81rem;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/ykGw7Z-nlBLFRSS3m19Qa.png);

    .title {
      max-width: 1.3rem;
    }

    .right {
      padding-right: 0.12rem;
    }

    .price * {
      color: #b7712b !important;
    }

    // .subtitle {
    //   margin-top: 4px;
    // }

    .subtitle * {
      color: #b97230 !important;
    }

    .subtitle {
      margin-top: 0.06rem;
    }

    .btn {
      background: linear-gradient(270deg, #c38f5a 0%, #deba7e 100%);
    }
  }

  &.type-1,
  &.type-2 {
    .diff {
      font-weight: normal;
    }

    .origin-price {
      opacity: 0.5;
    }

    .btn {
      background: linear-gradient(270deg, #c38f5a 0%, #deba7e 100%);
    }
  }

  &.type-3,
  &.type-4 {
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/vaD-vV1xfgZM2vdAdSQcJ.png);

    .corner {
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
    }

    .title {
      max-width: 1.5rem;
    }

    .btn {
      width: 0.68rem;
      height: 0.25rem;
      background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);
      border-radius: 0.13rem;
      position: relative;

      .hint {
        position: absolute;
        background: #ff5103;
        color: white;
        top: -0.19rem;
        right: -0.24rem;
        border-radius: 0.04rem;

        span {
          display: inline-block;
          transform: scale(0.8);
          transform-origin: center center;
        }

        &::after {
          content: "";
          z-index: 3;
          display: inline-block;
          border-top: 0.03rem #ff5103 solid;
          border-left: 0.03rem transparent solid;
          border-right: 0.03rem transparent solid;
          position: absolute;
          left: 20%;
          bottom: -0.02rem;
        }
      }
    }

    .subtitle {
      max-width: 1.5rem;
      display: block;
    }
  }

  &.disabled {
    &.type-3 {
      .current,
      .unit,
      .title,
      .status {
        color: #879099 !important;
      }

      .line {
        background: #879099 !important;
        opacity: 0.6;
      }
    }
  }

  &.type-1 {
    height: 0.72rem;
    padding-top: 0;
    padding-bottom: 0;
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/c976_Et0btmujqSP5G7WN.png);

    .left-container {
      .mid {
        justify-content: center;
      }
    }

    .price {
      &.length-2 {
        .current {
          font-size: 0.3rem;
        }

        .unit {
          font-size: 0.12rem;
        }
      }

      &.length-3 {
        .current {
          font-size: 0.3rem;
        }

        .unit {
          font-size: 0.14rem;
        }
      }

      &.length-4 {
        .current {
          font-size: 0.28rem;
        }

        .unit {
          font-size: 0.12rem;
        }
      }

      &.length-5 {
        .current {
          font-size: 0.24rem;
        }

        .unit {
          font-size: 0.12rem;
        }
      }
    }
  }

  &.type-3 {
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/zy8QDfbi_r9wc8vBNnrFQ.png);
    padding-top: 0.16rem;
    padding-bottom: 0.13rem;

    &.status-1 {
      .btn {
        background: #f4b797;
      }
    }

    &.disabled {
      background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/KjXs4wnjkJYM4hQ4LQ2YM.png);
      padding-bottom: 0.15rem;

      .corner {
        background: #bcc4cc;
      }

      .colored {
        background: linear-gradient(137deg, #acacac 0%, #838383 100%);
      }

      .right .btn {
        background: #bcc4cc;
        color: white;
        margin-top: 0;
      }
    }

    .left {
      width: 0.64rem;
      max-width: 0.64rem;
      overflow: hidden;
      text-overflow: ellipsis;

      .price {
        .current {
          font-size: 0.3rem;
          font-family: "DIN Alternate Bold", sans-serif;
          font-weight: bold;
          color: #f72626;
        }

        .unit {
          font-size: 0.14rem;
          font-weight: 500;
          color: #f72626;
          line-height: 1;
        }

        &.length-2 {
          .current {
            font-size: 0.42rem;
          }

          .unit {
            font-size: 0.12rem;
          }
        }

        &.length-3 {
          .current {
            font-size: 0.24rem;
          }

          .unit {
            font-size: 0.14rem;
          }
        }

        &.length-4 {
          .current {
            font-size: 0.2rem;
          }

          .unit {
            font-size: 0.12rem;
          }
        }
      }
    }

    &.status-2 {
      .right .btn {
        width: 0.68rem;
        height: 0.25rem;
        border-radius: 0.13rem;
        border: 1px solid #ff6011;
        background: inherit;
        color: #ff5526;
      }
    }

    .subtitle {
      margin-top: 0.09rem;
      line-height: 0.14rem;
    }
  }

  &.type-4 {
    background-image: url(https://m.hellobike.com/resource/AppPlatformH5/fuli/vaD-vV1xfgZM2vdAdSQcJ.png);

    .left-container {
      padding-left: 0.12rem;

      .title {
        max-width: 2rem;
        font-size: 0.16rem;
        font-weight: 500;
        color: #242729;
      }

      .subtitle {
        max-width: 2rem;
        font-size: 0.12rem;
        color: #5a6066;
      }
    }

    &.status-1 .right .btn {
      .mixin-btn-border();
    }

    &.status-2 .right .btn {
      .mixin-btn-border();
    }

    &.status-3 .right .btn {
      .mixin-btn-border();
    }

    &.status-4 .right .btn {
      .mixin-btn-border();
    }

    &.status-5 .right .btn {
      .mixin-btn-border();
    }
  }

  // .with-corner {
  //   .left-container .left {
  //     padding-top: 0.08rem;
  //   }
  // }
}
</style>
